<template>

    <v-page>

        <transition name="modal">
            <v-modal-project-create v-if="showModal === 'create'" @created="getProjects" />
            <v-modal-project-edit v-else-if="showModal === 'edit'" :model="selectedProject" @saved="getProjects" />
            <v-modal-project-delete v-else-if="showModal === 'delete'" :model="selectedProject" @deleted="getProjects" />
        </transition>

        <v-page-header title="Projects" icon="fas fa-folder-tree" />

        <v-page-filters>
            <v-searchbar :model="params.q" @input="params.q = $event" :action="getProjects" />
            <v-button size="sm" @click.native="createProject">Create Project</v-button>
        </v-page-filters>

        <v-page-body>
            <v-notice v-if="empty" title="Start a New Project" message="Create a project to get started.">
                <template #footer>
                    <v-button @click.native="createProject">Create Project</v-button>
                </template>
            </v-notice>
            <div v-if="!empty" class="projects">
                <v-project-tile v-for="p in projects"
                    :key="p.id"
                    :model="p"
                    @saved="getProjects"
                    @editProject="onEditProject(p)">
                </v-project-tile>
            </div>
        </v-page-body>

    </v-page>

</template>

<style scoped lang="scss">

    .projects {
        display: grid;
        grid-gap: 10px;
        grid-template-columns: 1fr 1fr 1fr;
    }

</style>

<script>

import MemberApi from '@api/MemberApi';
import ModalProjectCreate from '@modals/project/ModalProjectCreate';
import ModalProjectDelete from '@modals/project/ModalProjectDelete';
import ModalProjectEdit from '@modals/project/ModalProjectEdit';
import ProjectTile from './components/ProjectTile';

export default {

    components: {
        'v-modal-project-create': ModalProjectCreate,
        'v-modal-project-delete': ModalProjectDelete,
        'v-modal-project-edit': ModalProjectEdit,
        'v-project-tile': ProjectTile,
    },

    data() {
        return {
            projects: [],
            params: {},
            selectedProject: null,
        }
    },

    created() {
        this.getProjects();
    },

    computed: {

        empty() {
            return this.projects.length === 0;
        },

    },

    methods: {

        onEditProject(value) {
            this.selectedProject = value;
            this.$store.commit('showModal', 'edit');
        },

        getProjects() {
            this.$store.commit('loading', true);
            MemberApi.getProjects(this.$store.getters.user.member.id, this.params)
                .then((response) => {
                    this.$store.commit('loading', false);
                    this.projects = response.data.data;
                    this.$events.$emit('pageLoaded');
                }, () => {
                    this.$store.commit('loading', false);
                    this.$events.$emit('pageError');
                });
        },

        createProject() {
            this.$store.commit('showModal', 'create');
        },

    }

}

</script>
